import { AsegoDaysResponse } from '../../hooks/services/appointments/availabilities/asego'
import { AvailabilitiesResponse } from '../../types'

/**
 * Transforms AsegoDaysResponse to AvailabilitiesResponse format
 * This allows us to merge asego days with regular availabilities using existing merge logic
 *
 * The transformation converts the simple { isAvailable: boolean } structure to empty TimeBlock[]
 * arrays for available days. The actual time slots will be fetched when the user clicks on a
 * specific day in the UI, showing a skeleton loader until the detailed times arrive.
 */
const transformAsegoToAvailabilities = (asegoDays?: AsegoDaysResponse): AvailabilitiesResponse | undefined => {
  if (!asegoDays) {
    return undefined
  }

  const dayAvailability: AvailabilitiesResponse['dayAvailability'] = {}

  // Convert asego day structure to availability structure
  Object.keys(asegoDays.dayAvailability).forEach((dayKey) => {
    dayAvailability[dayKey] = {}

    Object.keys(asegoDays.dayAvailability[dayKey]).forEach((resourceId) => {
      const resourceDay = asegoDays.dayAvailability[dayKey][resourceId]

      // Only include resources that are marked as available
      if (resourceDay.isAvailable) {
        // Set empty array to indicate the day has availability
        // The actual time slots will be fetched when the user clicks on the date
        dayAvailability[dayKey][resourceId] = []
      }
    })
  })

  return {
    dayAvailability,
    responseStatus: asegoDays.responseStatus,
    resourceHasCalendarIntegration: asegoDays.resourceHasCalendarIntegration,
    hasAppointmentTypeMappingError: false,
  }
}

export { transformAsegoToAvailabilities }
